module.exports = __webpack_public_path__ + "img/cloud.567417ae.svg";